import { UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

// custom validator to check that start date is before the end date
export function ValidateDateRange(startDateControlName: string, endDateControlName: string): ValidatorFn {
  return (formGroup: UntypedFormGroup): ValidationErrors | null => {
    const startControl = formGroup.controls[startDateControlName];
    const endControl = formGroup.controls[endDateControlName];

    if (endControl.errors && !endControl.errors.isCompanyRequired) {
      // return if another validator has already found an error on the end control
      return null;
    }
    // return error if validation fails
    if (new Date(startControl.value) > new Date(endControl.value)) {
      startControl.setErrors({ dateRangeIncorrect: true });
      endControl.setErrors({ dateRangeIncorrect: true });
    } else {
      startControl.setErrors(null);
      endControl.setErrors(null);
    }
    return null;
  };
}
